/* eslint-disable react/prop-types */
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import Icon from "@mui/material/Icon";
import QrCodeIcon from "@mui/icons-material/QrCode";
import WebIcon from "@mui/icons-material/Web";
import MobileIcon from "@mui/icons-material/MobileFriendly";
import SmsIcon from "@mui/icons-material/Sms";
import { IconButton } from "@mui/material";
import DeviceIcon from "@mui/icons-material/TabletAndroid";
import moment from "moment";

const icons = {
  "web-application": <WebIcon fontSize="small" />,
  "mobile-application": <MobileIcon fontSize="small" />,
  "qr-code": <QrCodeIcon fontSize="small" />,
  sms: <SmsIcon fontSize="small" />,
  "phone-call": <Icon fontSize="small">phone</Icon>,
  "physical-clock": <DeviceIcon fontSize="small" />,
};
export default function tableConfig() {
  const visibleDetails = (d) =>
    d.settings &&
    typeof d.settings === "object" &&
    (d.settings.profileImage || d.settings.signShift || d.settings.collectIP);

  return {
    columns: [
      {
        Header: "Employee Number",
        accessor: "code",
        align: "left",
        types: ["employee", "contractor"],
      },
      { Header: "Name", accessor: "fullName", align: "left", types: ["employee", "contractor"] },
      {
        Header: "SubAccount",
        accessor: "project",
        align: "center",
        types: ["employee", "contractor"],
      },
      {
        Header: "Location",
        accessor: "location",
        align: "center",
        types: ["employee", "contractor"],
      },
      { Header: "Date", accessor: "date", align: "center", types: ["employee", "contractor"] },
      {
        Header: "Clock In",
        accessor: "clockIn",
        align: "center",
        types: ["employee", "contractor"],
      },
      {
        Header: "Clock Out",
        accessor: "clockOut",
        align: "center",
        types: ["employee", "contractor"],
      },
      {
        Header: "Total hours",
        accessor: "total",
        align: "center",
        types: ["employee", "contractor"],
      },
      { Header: "Rate", accessor: "rate", align: "center", types: ["contractor"] },
      { Header: "Amount", accessor: "amount", align: "center", types: ["contractor"] },
      { Header: "Type", accessor: "type", align: "center", types: ["employee", "contractor"] },
      { Header: "Origin", accessor: "origin", align: "center", types: ["employee", "contractor"] },
      {
        Header: "Details",
        accessor: "details",
        align: "center",
        types: ["employee", "contractor"],
      },
    ],
    getRows: (data, setShowPunchesDetails) =>
      data.map((d) => ({
        code: d.code,
        fullName: d.fullName,
        project: d.project,
        location: d.location,
        date: moment(d.date).format("MM-DD-YYYY"),
        rate: `$${d.rate}`,
        amount: `$${d.amount}`,
        clockIn: d.clockIn ? (
          <MDBox ml={-1}>
            <MDBadge badgeContent={d.clockIn} color="success" variant="gradient" size="sm" />
          </MDBox>
        ) : (
          ""
        ),
        clockOut: d.clockOut ? (
          <MDBox ml={-1}>
            <MDBadge badgeContent={d.clockOut} color="error" variant="gradient" size="sm" />
          </MDBox>
        ) : (
          ""
        ),
        total: d.total,
        types: d.type,
        origin: icons[d.device] || <Icon fontSize="small">phone</Icon>,
        details: visibleDetails(d) ? (
          <IconButton size="small" onClick={() => setShowPunchesDetails(d)}>
            <Icon fontSize="small">visibility</Icon>
          </IconButton>
        ) : (
          ""
        ),
      })),
  };
}
